import React from 'react';

import FieldError from 'ui-library/FieldError';

import {PARAMETER_TYPE_TO_READABLE} from './ParameterConstants';
import {ParameterType} from './ParameterTypes';

export default function AnalyticsParameterFieldError(props: {type: ParameterType}): JSX.Element {
  return <FieldError message={`Invalid ${PARAMETER_TYPE_TO_READABLE[props.type]}`} />;
}
